/** Persists booking list tab / filters so returning from details (or sidebar) keeps the same list. */

export const BOOKING_MGMT_UI_KEY = "vendor_booking_mgmt_ui_v1";

const MAIN_TABS = ["All Inquiries", "All Bookings"];
const INQUIRY_CATS = ["New Inquiries", "Accepted", "Decline"];
const BOOKING_CATS = [
  "New Booking",
  "Ongoing Service",
  "Completed Booking",
  "Cancelled Booking",
  "Rejected Booking",
];

function normalizeRecord(raw) {
  if (!raw || typeof raw !== "object") return null;
  const main = raw.activeMainTab;
  if (!MAIN_TABS.includes(main)) return null;
  const cats = main === "All Inquiries" ? INQUIRY_CATS : BOOKING_CATS;
  const cat = cats.includes(raw.activeDocumentCategory)
    ? raw.activeDocumentCategory
    : cats[0];
  const page =
    Number.isInteger(raw.currentPage) && raw.currentPage > 0
      ? raw.currentPage
      : 1;
  const search = typeof raw.search === "string" ? raw.search : "";
  return {
    activeMainTab: main,
    activeDocumentCategory: cat,
    currentPage: page,
    search,
  };
}

export function readBookingMgmtSessionUi() {
  try {
    const raw = sessionStorage.getItem(BOOKING_MGMT_UI_KEY);
    if (!raw) return null;
    return normalizeRecord(JSON.parse(raw));
  } catch {
    return null;
  }
}

export function writeBookingMgmtSessionUi(ui) {
  const n = normalizeRecord(ui);
  if (!n) return;
  try {
    sessionStorage.setItem(BOOKING_MGMT_UI_KEY, JSON.stringify(n));
  } catch {
    /* ignore quota / private mode */
  }
}

export function clearBookingMgmtSessionUi() {
  try {
    sessionStorage.removeItem(BOOKING_MGMT_UI_KEY);
  } catch {
    /* ignore */
  }
}

/** Pass into `<NavLink state={...} />` so sidebar opens the last-used list. */
export function getBookingManagementNavLinkState() {
  const n = readBookingMgmtSessionUi();
  if (!n) return undefined;
  return {
    activeMainTab: n.activeMainTab,
    activeDocumentCategory: n.activeDocumentCategory,
    currentPage: n.currentPage,
    search: n.search,
  };
}
